<template>
	<!-- contenuto di un prodotto combo salvato sulla riga ordine dal sito (item.combo), diviso per gruppo -->
	<div v-if="gruppi.length" class="combo-choices">
		<div class="combo-title"><v-icon x-small class="mr-1">mdi-gift-outline</v-icon>Contenuto del combo</div>
		<div v-for="gruppo in gruppi" :key="gruppo.nome" class="combo-group">
			<span v-if="gruppo.nome" class="combo-group-name">{{ gruppo.nome }}:</span>
			<span v-for="(riga, i) in gruppo.righe" :key="i" class="combo-line">
				{{ riga.qt }} × {{ riga.name || riga.sku }}<template v-if="riga.variant"> ({{ riga.variant }})</template><template v-if="riga.sku && riga.name"> · SKU {{ riga.sku }}</template
				><template v-if="riga.surcharge > 0"> · + {{ (riga.surcharge * riga.qt).toFixed(2) }} {{ currency }}</template
				><template v-if="i < gruppo.righe.length - 1">; </template>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ComboChoices',
	props: {
		combo: { type: [Array, Object], default: null },
		currency: { type: String, default: '' },
	},
	computed: {
		// righe raggruppate per gruppo, nell'ordine in cui arrivano
		gruppi() {
			const righe = Array.isArray(this.combo) ? this.combo : [];
			const gruppi = [];
			righe.forEach(riga => {
				const nome = riga.group_name || '';
				let gruppo = gruppi.find(g => g.nome === nome);
				if (!gruppo) {
					gruppo = { nome, righe: [] };
					gruppi.push(gruppo);
				}
				gruppo.righe.push(riga);
			});
			return gruppi;
		},
	},
};
</script>

<style scoped>
.combo-choices {
	margin-top: 4px;
	padding: 6px 8px;
	border-left: 3px solid #c9d3df;
	background: rgba(0, 0, 0, 0.02);
	border-radius: 4px;
	font-size: 12px;
	color: #5f6b7a;
	text-align: left;
}
.combo-title {
	font-weight: 600;
	color: #3c4652;
	margin-bottom: 2px;
}
.combo-group-name {
	font-weight: 600;
	text-transform: capitalize;
	margin-right: 4px;
}
</style>
